import React from 'react';
import Grid from '../Grid';
import { HeroStyled, TextHeader, Headline, Tag, ImageBlock, Button } from './styled';
import uLIcon from './ul-hero-icon.svg';

const Hero = () => {
  return (
    <HeroStyled>
      <Grid>
        <TextHeader>
          <Tag>
            <img
              src="https://cdn.auth0.com/website/universal-login/univ-login-hero-icon.svg"
              alt="Universal Login"
            />
            <h2>UNIVERSAL LOGIN</h2>
          </Tag>
          <Headline>
            Secure login infrastructure <br />to authenticate users <br /> to your apps
          </Headline>
          <Button href="javascript:signup()" className="btn btn-success btn-lg">
            Get Started
          </Button>
          <Button
            href="https://auth0.com/docs/hosted-pages/login"
            rel="external"
            className="btn btn-transparent btn-lg white"
          >
            Read The Docs
          </Button>
        </TextHeader>
        <ImageBlock>
          <img src="https://cdn.auth0.com/website/universal-login/exp_univ_login_hero.svg" alt="" />
        </ImageBlock>
      </Grid>
    </HeroStyled>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Hero/Hero.js